import React, { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";
import { FaEye } from "@react-icons/all-files/fa/FaEye";
import { FaEyeSlash } from "@react-icons/all-files/fa/FaEyeSlash";


function Login({ setActiveTab, onLogin, goToSignup, onAdminLogin, goToPayment }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [focusedInput, setFocusedInput] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    setAnimate(true);
  }, []);
const showToast = (message, type = 'success') => {
  setToast({ message, type });
  setTimeout(() => setToast(null), 3000);
};
const handleLogin = async (e) => {
  e.preventDefault();
  try {
    const res = await axios.post(`${API_BASE_URL}/login`, {
      username,
      password,
    });

    localStorage.setItem("token", res.data.token);
    localStorage.setItem("role", res.data.role);
    localStorage.setItem("username", res.data.username);

    // Check if user is admin
    if (res.data.role === "admin") {
      showToast("Admin login successful!", "success");
      // Add delay before redirect
      setTimeout(() => {
        if (onAdminLogin) {
          onAdminLogin(); // Switch to admin dashboard
        }
      }, 1500);
    } else {
      // Regular user login
      showToast("Login successful!", "success");
      // Add delay before redirect
      setTimeout(() => {
        if (onLogin) onLogin();
        if (setActiveTab) {
          setActiveTab("Send");
        }
      }, 1500);
    }
  } catch (err) {
    console.error("Login error:", err);
    
    // Handle payment pending case - 403 status
    if (err.response?.status === 403 && err.response?.data?.requiresPayment) {
      const userId = err.response.data.userId;
      
      // Store user info for payment
      localStorage.setItem("pendingPaymentUserId", userId);
      localStorage.setItem("pendingPaymentUsername", username);
      
      showToast("Payment pending! Redirecting to payment page...", "info");
      
      // Add delay before redirect
      setTimeout(() => {
        if (goToPayment) {
          goToPayment(userId);
        }
      }, 1500);
    } else {
      showToast(err.response?.data?.error || "Invalid username or password", "error");
    }
  }
};



  const getInputStyle = (inputName) => {
    return {
      width: "100%",
      height: "48px",
      padding: "0 14px",
      borderWidth: "1.5px",
      borderStyle: "solid",
      borderColor: focusedInput === inputName ? "#1f2937" : "#e5e7eb",
      borderRadius: "10px",
      fontSize: "15px",
      color: "#1f2937",
      backgroundColor: focusedInput === inputName ? "#fff" : "#fafafa",
      outline: "none",
      boxSizing: "border-box",
      transition: "all 0.3s",
    };
  };

  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "100vh",
      // backgroundColor: "#fafafa",
      padding: "20px",
    },
    form: {
      width: "100%",
      maxWidth: "340px",
      backgroundColor: "#fff",
      padding: "36px",
      borderRadius: "16px",
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
      opacity: animate ? 1 : 0,
      transform: animate ? "scale(1)" : "scale(0.95)",
      transition: "all 0.5s ease",
    },
    iconContainer: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginBottom: "24px",
      animation: animate ? "rotate 1s ease-out" : "none",
    },
    iconOuter: {
      width: "90px",
      height: "90px",
      borderRadius: "45px",
      backgroundColor: "#f3f4f6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    iconInner: {
      width: "70px",
      height: "70px",
      borderRadius: "35px",
      backgroundColor: "#1f2937",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    iconText: {
      fontSize: "36px",
    },
    iconImage: {
      width: '64px',
      height: '24px',
      objectFit: 'contain'
    },
    heading: {
      fontSize: "28px",
      fontWeight: "700",
      color: "#1f2937",
      marginBottom: "6px",
      textAlign: "center",
      letterSpacing: "-0.5px",
    },
    subheading: {
      fontSize: "15px",
      color: "#6b7280",
      textAlign: "center",
      marginBottom: "28px",
    },
    inputWrapper: {
      marginBottom: "20px",
    },
    label: {
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151",
      marginBottom: "8px",
      display: "block",
    },
    passwordContainer: {
      position: "relative",
      display: "flex",
      alignItems: "center",
    },
    passwordInput: {
      paddingRight: "40px",
    },
    eyeIcon: {
      position: "absolute",
      right: "14px",
      cursor: "pointer",
      fontSize: "18px",
      color: "#6b7280",
      userSelect: "none",
    },
    button: {
      width: "100%",
      height: "48px",
      backgroundColor: "#1f2937",
      borderRadius: "10px",
      color: "#fff",
      fontSize: "16px",
      fontWeight: "600",
      letterSpacing: "0.3px",
      border: "none",
      cursor: "pointer",
      marginTop: "8px",
      marginBottom: "20px",
      transition: "background-color 0.3s",
    },
    buttonHover: {
      backgroundColor: "#374151",
    },
    signupContainer: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "center",
      alignItems: "center",
      gap: "4px",
      flexWrap: "wrap",
    },
    signupText: {
      fontSize: "14px",
      color: "#6b7280",
    },
    signupLink: {
      fontSize: "14px",
      color: "#1f2937",
      fontWeight: "600",
      cursor: "pointer",
      textDecoration: "none",
    },
  };

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          /* Mobile responsiveness */
          @media (max-width: 480px) {
            .login-form {
              padding: 24px !important;
              border-radius: 12px !important;
            }
            
            .login-heading {
              font-size: 24px !important;
            }
            
            .login-subheading {
              font-size: 14px !important;
            }
            
            .icon-outer {
              width: 75px !important;
              height: 75px !important;
            }
            
            .icon-inner {
              width: 60px !important;
              height: 60px !important;
            }
            
            .icon-image {
              width: 54px !important;
              height: 20px !important;
            }
          }

          @media (max-width: 360px) {
            .login-form {
              padding: 20px !important;
            }
            
            .login-heading {
              font-size: 22px !important;
            }
            
            .signup-container {
              flex-direction: column !important;
              gap: 2px !important;
            }
          }
            @keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
        `}
      </style>
      {toast && (
  <div style={{
    position: 'fixed',
    top: '20px',
    right: '20px',
    backgroundColor: toast.type === 'error' ? '#ef4444' : toast.type === 'info' ? '#3b82f6' : '#10b981',
    color: '#fff',
    padding: '16px 24px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
    minWidth: '250px',
    animation: 'slideIn 0.3s ease-out',
    fontSize: '14px',
    fontWeight: '500',
  }}>
    {toast.message}
  </div>
)}

      <form onSubmit={handleLogin} style={styles.form} className="login-form">
        {/* Animated Icon */}
        <div style={styles.iconContainer}>
          <div style={styles.iconOuter} className="icon-outer">
            <div style={styles.iconInner} className="icon-inner">
              <img 
                src="/images/logo.jpeg" 
                alt="Logo" 
                style={styles.iconImage}
                className="icon-image"
              />
            </div>
          </div>
        </div>

        <h2 style={styles.heading} className="login-heading">Welcome Back</h2>
        <p style={styles.subheading} className="login-subheading">Sign in to your account</p>

        <div style={styles.inputWrapper}>
          <label style={styles.label}>Username</label>
          <input
            style={getInputStyle("username")}
            placeholder="Enter username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onFocus={() => setFocusedInput("username")}
            onBlur={() => setFocusedInput(null)}
            autoComplete="off"
          />
        </div>

        {/* Password field with eye toggle */}
        <div style={styles.inputWrapper}>
          <label style={styles.label}>Password</label>
          <div style={styles.passwordContainer}>
            <input
              style={{
                ...getInputStyle("password"),
                ...styles.passwordInput,
              }}
              placeholder="Enter password"
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              onFocus={() => setFocusedInput("password")}
              onBlur={() => setFocusedInput(null)}
              autoComplete="off"
            />
           <span
  style={styles.eyeIcon}
  onClick={() => setShowPassword(!showPassword)}
>
  {showPassword ? <FaEye /> : <FaEyeSlash />}
</span>
          </div>
        </div>

        <button
          style={styles.button}
          type="submit"
          onMouseOver={(e) =>
            (e.target.style.backgroundColor =
              styles.buttonHover.backgroundColor)
          }
          onMouseOut={(e) =>
            (e.target.style.backgroundColor = styles.button.backgroundColor)
          }
        >
          Sign In
        </button>

        <div style={styles.signupContainer} className="signup-container">
          <span style={styles.signupText}>Don't have an account?</span>
          <span style={styles.signupLink} onClick={goToSignup}>
            Sign Up
          </span>
        </div>
      </form>
    </div>
  );
}

export default Login;
